const fmt = require("indian-number-format");

export default function Total({ totalSummary, userType }) {
  const booked = totalSummary?.booked || 0;
  const deposit_total = totalSummary?.deposit_total || 0;
  const deposit_current = totalSummary?.deposit_current || 0;
  const upper = totalSummary?.upper || 0;
  const self = totalSummary?.self || 0;
  const lower = totalSummary?.lower || 0;
  const upperLive = totalSummary?.upperLive || 0;
  const selfLive = totalSummary?.selfLive || 0;
  const lowerLive = totalSummary?.lowerLive || 0;
  const total = totalSummary?.total || 0;

  return (
    <div className="menuContainer NetTotalCard ">
      {userType === 1 ? (
        <div className="menuUsername primarytext">SUPER</div>
      ) : null}
      {userType === 1 || userType === 2 ? (
        <div className="menuUsername primarytext">MASTER</div>
      ) : null}
      <div className="menuUsername primarytext">TOTAL</div>
      <div className={`menuUsername ${booked > 0 ? "buytext" : "selltext"} `}>
        {fmt.format(Math.abs(booked))}
      </div>
      <div className={`menuName`}>{fmt.format(deposit_total)}</div>
      <div className={`menuName`}>{fmt.format(deposit_current)}</div>
      <div className={`menuName ${upper > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(upper))}
      </div>
      <div className={`menuName ${self > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(self))}
      </div>
      <div className={`menuName ${lower > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(lower))}
      </div>
      <div className={`menuName ${upperLive > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(upperLive))}
      </div>
      <div className={`menuName ${selfLive > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(selfLive))}
      </div>
      <div className={`menuName ${lowerLive > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(lowerLive))}
      </div>
      <div className={`menuName ${total > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(Math.abs(total))}
      </div>
    </div>
  );
}
